module.exports = __webpack_public_path__ + "assets/text-style.3f9d9522.svg";